import { ExamLocationRequestApprovalType, ExamLocationVerdict } from '@exam-center/graphql';
import { z } from 'zod';

export const examCenterLocationRequestVerdictFormSchema = z
  .object({
    verdict: z.nativeEnum(ExamLocationVerdict).optional(),
    comment: z.string().optional(),
    action: z.enum(['submit', 'save']).optional(),
    approvalType: z
      .nativeEnum(ExamLocationRequestApprovalType, {
        required_error: 'กรุณาจัดการสิทธิ์การใช้งานสถานที่',
      })
      .optional(),
    grantedRoomId: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.action === 'submit') {
      if (!data.verdict) {
        ctx.addIssue({
          path: ['verdict'],
          code: z.ZodIssueCode.custom,
          message: 'กรุณาเลือกผลการอนุมัติคำขอ',
        });
      }
      if (data.verdict === ExamLocationVerdict.Approved && !data.approvalType) {
        ctx.addIssue({
          path: ['approvalType'],
          code: z.ZodIssueCode.custom,
          message: 'กรุณาจัดการสิทธิ์การใช้งานสถานที่',
        });
      }
    }
  });

export type ExamCenterLocationRequestVerdictFormType = z.infer<
  typeof examCenterLocationRequestVerdictFormSchema
>;
